/**
 * Internal-auth header helper (2026-05-30).
 *
 * When the Next.js server (SSR / RSC / route handlers) fetches the
 * Mio API, the request goes through DigitalOcean's public load
 * balancer and arrives at the api container without a private-IP
 * X-Forwarded-For and without an Origin header. The api's
 * SearchSecurityMiddleware would reject those calls as 403.
 *
 * This helper returns the headers needed for the server-to-server
 * call to be recognised as a trusted internal caller. When the code
 * runs in the browser (window defined) it returns an empty object so
 * the secret never leaks into a client bundle.
 *
 * The middleware bypasses every gate check (origin, rate limit) when
 * this header is present and matches the secret. Empty secret on the
 * server disables the bypass entirely — calls fall through to the
 * normal gate.
 */
export function getInternalAuthHeaders(): Record<string, string> {
  if (typeof window !== "undefined") return {};
  const secret = process.env.INTERNAL_API_SHARED_SECRET;
  if (!secret || secret.trim() === "") return {};
  return { "x-internal-auth": secret.trim() };
}
